import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Modal } from 'antd';
import Actions from '../../actions';
// Components
import ManagePendingRequest from '../../Modals/ManagePendingRequest';

// Local Deps
import './RFQRecipientGrid.scss';

export default class RFQRecipient extends React.PureComponent {
  static propTypes = {
    participants: PropTypes.array,
    handleSelectedActions: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    participants: [
      {
        companyName: "Debby's Test Casting",
        convoId: '0',
        deliveryDate: null,
        ndaAccept: '0',
        quantity: '1',
        quoteDate: null,
        rfqCreateDate: '2020-11-13',
        shipping: '0',
        status: 'Requested',
        totalCost: '0',
        unitPrice: '0',
      },
    ],
  };

  static initialState = {
    modalDisplayed: false,
  };

  state = RFQRecipient.initialState;

  _ToggleModal = modalDisplayed => this.setState({ modalDisplayed });

  render() {
    const { participants, handleSelectedActions, readOnly } = this.props;
    const { modalDisplayed } = this.state;
    const pageSize = 5;

    // Note that the grid configFile for this directory does not configure the request table, but the details table inside of the modal.
    const columns = [
      {
        Header: 'Company Name',
        accessor: 'companyName',
      },
      {
        Header: 'Quote Request Date ',
        accessor: 'rfqCreateDate',
      },
      {
        Header: 'Delivery Date',
        accessor: 'deliveryDate',
      },
      {
        Header: 'Quote Status',
        accessor: 'status',
      },
      {
        Header: 'Action',
        accessor: 'action',
        minWidth: 130,
        Cell: cellProps => (
          <Actions
            hideDelete={readOnly}
            hideMessage={!readOnly}
            cellProps={cellProps}
            fullCellProps
            selectedAction={handleSelectedActions}
          />
        ),
      },
    ];

    return (
      <div className="nf-view-users-grid">
        <ReactTable
          data={participants}
          columns={columns}
          showPageSizeOptions={false}
          showPagination={participants.length > pageSize}
          noDataText="Please Add Recipents for The RFQ"
          defaultPageSize={pageSize}
        />
        <Modal
          visible={modalDisplayed}
          onOk={() => this._ToggleModal(false)}
          okText="Save"
          onCancel={() => this._ToggleModal(false)}
          closable={false}
          title="Account Details"
          width="70%"
        >
          <ManagePendingRequest />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/RFQRecipientGrid/RFQRecipientGrid.jsx